import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SelectInputAsync from "./SlectInputAsync";
import TextInput from "./TextInput";
import Modal from "components/Modal";
import TextEditorInput from "./TextEditorInput";

const FieldWithTranslation: React.FC<{ isTextarea?: boolean; name: string; customError?: string; withModal?: boolean; isDescription?: boolean; label?: string }> = ({ isTextarea, name, label, customError, withModal, isDescription }) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${name}`,
  });
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="mb-6">
        <div className="flex gap-10 items-center mb-3 parent-animation-on-hover bg-colorWhite10 px-2 py-2 rounded-md justify-between cursor-pointer" onClick={withModal ? () => setIsModalOpen(true) : () => append({ language: null, value: null })}>
          <h2 className="text-sm font-semibold ">{t("addEditASomethingTranslation", { changeablePart: label ? t(label) : t(name) })}</h2>
          <FontAwesomeIcon icon={faPlus} className="squish-on-hover cursor-pointer text-info" title={t("addDynamic", { changeablePart: label ? t(label) : t(name) })} />
        </div>
        {(errors[name] as any)?.message && <p className="text-sm text-danger -mt-1">{String((errors[name] as any)?.message)}</p>}
        {customError && <p className="text-sm text-danger -mt-1">{customError}</p>}

        {!withModal ? (
          fields.map((field: any, index) => {
            const languageFieldName = `${name}.${index}.language`;
            const watchedLanguage = watch(languageFieldName);
            return (
              <div key={field.id} className={`mb-4 border p-4 rounded-lg border-borderWhite5 parent-animation-on-hover`}>
                <div className="flex justify-between items-center mb-2">
                  <h3>
                    {label ? t(label) : t(name)} / <span className="font-bold">{watchedLanguage ? watchedLanguage.label : t("unknown")}</span>
                  </h3>
                  <FontAwesomeIcon icon={faMinus} className="cursor-pointer text-danger" title={t("removeDynamic", { changeablePart: label ? t(label) : t(name) })} onClick={() => remove(index)} />
                </div>
                <Controller name={`${name}.${index}.language`} control={control} render={({ field, fieldState: { error } }) => <SelectInputAsync {...field} apiName="languages" isRequired valueIsCode customError={error?.message} />} />
                <Controller
                  name={`${name}.${index}.value`}
                  control={control}
                  render={({ field, fieldState: { error } }) =>
                    isDescription ? (
                      <TextEditorInput {...field} placeholder={t("enterYourHere", { changeablePart: label ? t(label) : t(name) })} size="full" isRequired customError={error?.message} />
                    ) : isTextarea ? (
                      <TextInput type="textarea" {...field} placeholder={t("enterYourHere", { changeablePart: label ? t(label) : t(name) })} size="full" isRequired customError={error?.message} />
                    ) : (
                      <TextInput {...field} placeholder={t("enterYourHere", { changeablePart: label ? t(label) : t(name) })} size="full" isRequired customError={error?.message} />
                    )
                  }
                />
              </div>
            );
          })
        ) : fields.length ? (
          <div className="border dark:border-white/20 border-black/20 px-2 py-1 rounded-md flex flex-col gap-1">
            {fields.map((field: any, index: number) => {
              const languageFieldName = `${name}.${index}.language`;
              const valueFieldName = `${name}.${index}.value`;
              const watchedLanguage = watch(languageFieldName);
              const watchedValue = watch(valueFieldName);

              return (
                <div key={field.id} className="mb-1">
                  <p className="font-normal text-xs mt-1 max-w-[98%] truncate " key={field.value}>
                    <span className="text-xs opacity-40 font-semibold">
                      {label ? t(label) : t(name)} / {watchedLanguage ? watchedLanguage.label : t("unknown")}
                    </span>
                    : {watchedValue}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
      </div>
      {withModal && (
        <Modal isOpen={isModalOpen} onClose={handleCloseModal} title={t("add/editDynamic", { changeablePart: label ? t(label) : t(name) })} size="super" withFixedButton buttonText={t("save")}>
          <div className="flex gap-10 items-center mb-3 parent-animation-on-hover bg-colorWhite10 p-4 rounded-lg justify-between cursor-pointer" onClick={() => append({ language: null, value: null })}>
            <h2 className="text-md font-semibold ">{t("addASomethingTranslation", { changeablePart: label ? t(label) : t(name) })}</h2>
            <FontAwesomeIcon icon={faPlus} className="squish-on-hover cursor-pointer text-info" title={t("addDynamic", { changeablePart: label ? t(label) : t(name) })} />
          </div>
          {fields.length
            ? fields.map((field: any, index) => {
                const languageFieldName = `${name}.${index}.language`;
                const watchedLanguage = watch(languageFieldName);
                return (
                  <div key={field.id} className={`mb-4 border p-4 rounded-lg border-borderWhite5 parent-animation-on-hover`}>
                    <div className="flex justify-between items-center mb-2">
                      <h3>
                        {label ? t(label) : t(name)} / <span className="font-bold">{watchedLanguage ? watchedLanguage.label : t("unknown")}</span>
                      </h3>
                      <FontAwesomeIcon icon={faMinus} className="cursor-pointer text-danger" title={t("removeDynamic", { changeablePart: label ? t(label) : t(name) })} onClick={() => remove(index)} />
                    </div>
                    <Controller name={`${name}.${index}.language`} control={control} render={({ field, fieldState: { error } }) => <SelectInputAsync {...field} apiName="languages" isRequired valueIsCode customError={error?.message} />} />
                    <Controller
                      name={`${name}.${index}.value`}
                      control={control}
                      render={({ field, fieldState: { error } }) =>
                        isDescription ? (
                          <TextEditorInput {...field} placeholder={t("enterYourHere", { changeablePart: label ? t(label) : t(name) })} size="full" isRequired customError={error?.message} />
                        ) : (
                          <TextInput {...field} placeholder={t("enterYourHere", { changeablePart: label ? t(label) : t(name) })} size="full" isRequired customError={error?.message} />
                        )
                      }
                    />
                  </div>
                );
              })
            : ""}
        </Modal>
      )}
    </>
  );
};

export default FieldWithTranslation;
